<div class="scene-list__viewer">
  <ocp-scene-thumbnail
    class="scene-list__thumbnail"
    [thumbnailUrl]="currentScene()?.thumbnailUrl"
    [alt]="'scene-list.scene-thumbnail-alt' | translate"
    [priority]="true"
    tabindex="0"
    role="button"
    [attr.aria-label]="'task-detail.open-scene' | translate"
    (click)="onSceneClick($event)"
    (keydown)="onSceneKeyDown($event)"
  >
    @if (canViewInModel()) {
      <span class="scene-list__open-scene-action">
        <button
          hlmBtn
          type="button"
          class="scene-list__open-scene-btn"
          data-testid="open-scene-btn"
          [attr.aria-label]="'task-detail.open-scene' | translate"
          (click)="onViewInModel($event)"
        >
          {{ 'task-detail.open-scene' | translate }}
        </button>
      </span>
    }
    <span class="scene-list__secondary-actions">
      @if (canUpdate()) {
        <button
          hlmBtn
          type="button"
          variant="ghost"
          size="icon"
          class="scene-list__icon-action-btn"
          [attr.aria-label]="'scene-list.update-scene' | translate"
          [disabled]="sceneOperationPending()"
          (click)="onUpdateScene($event)"
        >
          <ocp-themed-icon name="update.svg" [size]="20" aria-hidden="true" />
        </button>
      }
      @if (canDelete()) {
        <button
          hlmBtn
          type="button"
          variant="ghost"
          size="icon"
          class="scene-list__icon-action-btn"
          [attr.aria-label]="'scene-list.delete-scene' | translate"
          [disabled]="sceneOperationPending()"
          (click)="onDeleteScene($event)"
        >
          <ocp-themed-icon name="trash-plain.svg" [size]="24" aria-hidden="true" />
        </button>
      }
    </span>
  </ocp-scene-thumbnail>

  <span class="scene-list__selected-count">{{
    'scene-list.selected-objects' | translate: { count: selectedObjectsCount() }
  }}</span>
</div>
@if (totalScenes() > 1) {
  <ocp-pagination
    class="scene-list__pagination"
    [totalPages]="totalScenes()"
    [activeIndex]="currentIndex()"
    [maxVisiblePages]="3"
    (activeIndexChange)="activeIndexChange.emit($event)"
  />
}
